import {CHAINS, ConnectionType} from './config';
import {Connector} from "wagmi";
import {buildGnosisSafeConnector} from "~/utils/wallets/gnosis-safe";
import {buildMetaMaskConnector} from "~/utils/wallets/metamask";
import {buildWalletConnectConnector} from "~/utils/wallets/wallet-connect";
import {buildInjectedConnector} from "~/utils/wallets/injected";

export interface Connection {
    // connector: Connector
    // hooks: Web3ReactHooks
    type: ConnectionType
}

export type Login = (connectionType: ConnectionType) => void;

// function getIsBraveWallet(): boolean {
//   return window.ethereum?.isBraveWallet ?? false
// }

// export function getHasMetaMaskExtensionInstalled(): boolean {
//   return (window.ethereum?.isMetaMask ?? false) && !getIsBraveWallet()
// }

export function onConnectionError(error: Error) {
    console.debug(`web3-react error: ${error}`)
}

export const PRIORITIZED_CONNECTORS: { [key in ConnectionType]: Connector } = {
    // [ConnectionType.INJECTED]: buildInjectedConnector(CHAINS),
    [ConnectionType.METAMASK]: buildMetaMaskConnector(CHAINS),
    [ConnectionType.WALLET_CONNECT]: buildWalletConnectConnector(CHAINS),
    // [ConnectionType.GNOSIS_SAFE]: buildGnosisSafeConnector(CHAINS),
}

export const connectors = Object.values(PRIORITIZED_CONNECTORS)

// export function getConnection(c: Connector | ConnectionType) {
//     if (c instanceof Connector) {
//         const connection = Object.values(PRIORITIZED_CONNECTORS).find((connection) => connection === c)
//         if (!connection) {
//             throw Error('Unsupported Connector')
//         }
//         return connection
//     } else {
//         switch (c) {
//             // case ConnectionType.INJECTED:
//             //   return PRIORITIZED_CONNECTORS[ConnectionType.INJECTED]
//             case ConnectionType.METAMASK:
//                 return PRIORITIZED_CONNECTORS[ConnectionType.METAMASK]
//             // case ConnectionType.WALLET_CONNECT:
//             //     return PRIORITIZED_CONNECTORS[ConnectionType.WALLET_CONNECT]
//             case ConnectionType.GNOSIS_SAFE:
//                 return PRIORITIZED_CONNECTORS[ConnectionType.GNOSIS_SAFE]
//             // case ConnectionType.NETWORK:
//             //   return PRIORITIZED_CONNECTORS[ConnectionType.NETWORK]
//         }
//     }
// }

// export const switchNetwork = async (chainId: number, connectionType: ConnectionType | null) => {
//   if (!connectionType) {
//     return
//   }
//
//   const { connector } = getConnection(connectionType)
//
//   if (connectionType === ConnectionType.WALLET_CONNECT || connectionType === ConnectionType.NETWORK) {
//     await connector.activate(chainId)
//     return
//   }
//
//   const chainInfo = CHAIN_INFO[chainId]
//   const addChainParameter: AddEthereumChainParameter = {
//     chainId,
//     chainName: chainInfo.label,
//     rpcUrls: [chainInfo.rpcUrl],
//     nativeCurrency: chainInfo.nativeCurrency,
//     blockExplorerUrls: [chainInfo.explorer],
//   }
//   await connector.activate(addChainParameter)
// }

// export const tryActivateConnector = async (connector: Connector): Promise<ConnectionType | undefined> => {
//   await connector.activate()
//   const connectionType = getConnection(connector).type
//   return connectionType
// }
//
// export const tryDeactivateConnector = async (connector: Connector): Promise<null | undefined> => {
//   connector.deactivate?.()
//   connector.resetState()
//   return null
// }
